import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { HomologBanner } from './components/HomologBanner'
import { HubLayout } from './components/HubLayout'
import { HubPageSkeleton } from './components/HubPageSkeleton'
import { LOGIN_PATH } from './lib/hubPath'
import { loadMenuPage, loadPerfilPage } from './lib/routeChunks'
import { ConvidarPage } from './pages/ConvidarPage'
import { ForgotPasswordPage } from './pages/ForgotPasswordPage'
import { HubPage } from './pages/HubPage'
import { LoginPage } from './pages/LoginPage'

/** Páginas fora do caminho crítico (login / início / convidar) — code-split. */
const AgendaPage = lazy(() => import('./pages/AgendaPage').then((m) => ({ default: m.AgendaPage })))
const AvisoPage = lazy(() => import('./pages/AvisoPage').then((m) => ({ default: m.AvisoPage })))
const AvisosPage = lazy(() => import('./pages/AvisosPage').then((m) => ({ default: m.AvisosPage })))
const ArvorePage = lazy(() => import('./pages/ArvorePage').then((m) => ({ default: m.ArvorePage })))
const ColinhaPage = lazy(() => import('./pages/ColinhaPage').then((m) => ({ default: m.ColinhaPage })))
const ConvidadosPage = lazy(() =>
  import('./pages/ConvidadosPage').then((m) => ({ default: m.ConvidadosPage })),
)
const BiografiaPage = lazy(() =>
  import('./pages/BiografiaPage').then((m) => ({ default: m.BiografiaPage })),
)
const CadastroPage = lazy(() => import('./pages/CadastroPage').then((m) => ({ default: m.CadastroPage })))
const EnquetePage = lazy(() => import('./pages/EnquetePage').then((m) => ({ default: m.EnquetePage })))
const EnquetesPage = lazy(() => import('./pages/EnquetesPage').then((m) => ({ default: m.EnquetesPage })))
const EventoEditarPage = lazy(() =>
  import('./pages/EventoEditarPage').then((m) => ({ default: m.EventoEditarPage })),
)
const EventoNovaPage = lazy(() =>
  import('./pages/EventoNovaPage').then((m) => ({ default: m.EventoNovaPage })),
)
const EventoPage = lazy(() => import('./pages/EventoPage').then((m) => ({ default: m.EventoPage })))
const EventosPage = lazy(() => import('./pages/EventosPage').then((m) => ({ default: m.EventosPage })))
const EuApoioPage = lazy(() => import('./pages/EuApoioPage').then((m) => ({ default: m.EuApoioPage })))
const FichaPage = lazy(() => import('./pages/FichaPage').then((m) => ({ default: m.FichaPage })))
const LegislacaoItemPage = lazy(() =>
  import('./pages/LegislacaoItemPage').then((m) => ({ default: m.LegislacaoItemPage })),
)
const LegislacaoPage = lazy(() =>
  import('./pages/LegislacaoPage').then((m) => ({ default: m.LegislacaoPage })),
)
const MedalhasPage = lazy(() => import('./pages/MedalhasPage').then((m) => ({ default: m.MedalhasPage })))
const MissoesPage = lazy(() => import('./pages/MissoesPage').then((m) => ({ default: m.MissoesPage })))
const MenuPage = lazy(loadMenuPage)
const PerfilPage = lazy(loadPerfilPage)
const PontuacaoPage = lazy(() =>
  import('./pages/PontuacaoPage').then((m) => ({ default: m.PontuacaoPage })),
)
const SenhaPage = lazy(() => import('./pages/SenhaPage').then((m) => ({ default: m.SenhaPage })))
const SolicitacaoPage = lazy(() =>
  import('./pages/SolicitacaoPage').then((m) => ({ default: m.SolicitacaoPage })),
)
const SolicitacaoNovaPage = lazy(() =>
  import('./pages/SolicitacaoNovaPage').then((m) => ({ default: m.SolicitacaoNovaPage })),
)
const SolicitacoesPage = lazy(() =>
  import('./pages/SolicitacoesPage').then((m) => ({ default: m.SolicitacoesPage })),
)
const NoticiaPage = lazy(() => import('./pages/NoticiaPage').then((m) => ({ default: m.NoticiaPage })))
const NoticiasPage = lazy(() => import('./pages/NoticiasPage').then((m) => ({ default: m.NoticiasPage })))
const RankingPage = lazy(() => import('./pages/RankingPage').then((m) => ({ default: m.RankingPage })))
const RedesPage = lazy(() => import('./pages/RedesPage').then((m) => ({ default: m.RedesPage })))
const VideoPage = lazy(() => import('./pages/VideoPage').then((m) => ({ default: m.VideoPage })))
const VideosPage = lazy(() => import('./pages/VideosPage').then((m) => ({ default: m.VideosPage })))

const ConviteShowPage = lazy(() =>
  import('./pages/ConviteShowPage').then((m) => ({ default: m.ConviteShowPage })),
)
const ConviteBemVindoPage = lazy(() =>
  import('./pages/ConviteBemVindoPage').then((m) => ({ default: m.ConviteBemVindoPage })),
)
const ConviteConfirmarWhatsappPage = lazy(() =>
  import('./pages/ConviteConfirmarWhatsappPage').then((m) => ({
    default: m.ConviteConfirmarWhatsappPage,
  })),
)
const BioPublicaPage = lazy(() =>
  import('./pages/BioPublicaPage').then((m) => ({ default: m.BioPublicaPage })),
)

function HubLoginRedirect() {
  const { search } = useLocation()
  return <Navigate to={`${LOGIN_PATH}${search}`} replace />
}

export default function App() {
  return (
    <>
      <HomologBanner />
      <Routes>
        <Route
          path="/convite/bem-vindo"
          element={
            <Suspense
              fallback={
                <div className="bp-page">
                  <HubPageSkeleton />
                </div>
              }
            >
              <ConviteBemVindoPage />
            </Suspense>
          }
        />
        <Route
          path="/convite/confirmar-whatsapp"
          element={
            <Suspense
              fallback={
                <div className="bp-page">
                  <HubPageSkeleton />
                </div>
              }
            >
              <ConviteConfirmarWhatsappPage />
            </Suspense>
          }
        />
        <Route
          path="/convite/:id"
          element={
            <Suspense
              fallback={
                <div className="bp-page">
                  <HubPageSkeleton />
                </div>
              }
            >
              <ConviteShowPage />
            </Suspense>
          }
        />
        <Route
          path="/bio/:slug"
          element={
            <Suspense
              fallback={
                <div className="bp-page">
                  <HubPageSkeleton />
                </div>
              }
            >
              <BioPublicaPage />
            </Suspense>
          }
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/hub/login" element={<HubLoginRedirect />} />
        <Route path="/hub" element={<HubLayout />}>
          <Route index element={<Navigate to="/hub/inicio" replace />} />
          <Route path="inicio" element={<HubPage />} />
          <Route path="convidar" element={<ConvidarPage />} />
          <Route path="rede" element={<MenuPage kind="rede" />} />
          <Route path="campanha" element={<MenuPage kind="campanha" />} />
          <Route path="perfil" element={<PerfilPage />} />
          <Route path="cadastro" element={<CadastroPage />} />
          <Route path="senha" element={<SenhaPage />} />
          <Route path="ficha" element={<FichaPage />} />
          <Route path="equipe" element={<Navigate to="/hub/convidados" replace />} />
          <Route path="convidados" element={<ConvidadosPage />} />
          <Route path="arvore" element={<ArvorePage />} />
          <Route path="arvore/nivel/:nivel/:pessoa" element={<ArvorePage />} />
          <Route path="medalhas" element={<MedalhasPage />} />
          <Route path="ranking" element={<RankingPage />} />
          <Route path="pontuacao" element={<PontuacaoPage />} />
          <Route path="solicitacoes" element={<SolicitacoesPage />} />
          <Route path="solicitacoes/nova" element={<SolicitacaoNovaPage />} />
          <Route path="solicitacoes/:id" element={<SolicitacaoPage />} />
          <Route path="missoes" element={<MissoesPage />} />
          <Route path="noticias" element={<NoticiasPage />} />
          <Route path="noticias/:id" element={<NoticiaPage />} />
          <Route path="videos" element={<VideosPage />} />
          <Route path="videos/:id" element={<VideoPage />} />
          <Route path="biografia" element={<BiografiaPage />} />
          <Route path="eu-apoio" element={<EuApoioPage />} />
          <Route path="colinha" element={<ColinhaPage />} />
          <Route path="agenda" element={<AgendaPage />} />
          <Route path="avisos" element={<AvisosPage />} />
          <Route path="avisos/:id" element={<AvisoPage />} />
          <Route path="redes" element={<RedesPage />} />
          <Route path="eventos" element={<EventosPage />} />
          <Route path="eventos/nova" element={<EventoNovaPage />} />
          <Route path="eventos/:id/editar" element={<EventoEditarPage />} />
          <Route path="eventos/:id" element={<EventoPage />} />
          <Route path="enquetes" element={<EnquetesPage />} />
          <Route path="enquetes/:id" element={<EnquetePage />} />
          <Route path="legislacao" element={<LegislacaoPage />} />
          <Route path="legislacao/:id" element={<LegislacaoItemPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/hub/inicio" replace />} />
      </Routes>
    </>
  )
}
